export const getBlockDeletedCopy = (name: string) => `<p>${name}&nbsp;has hereby been removed</p>`;
